import React from 'react';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { NuvoText } from '@nuvolo/nuux-core/components/NuvoText';
import { nuvoloLogo as NuvoloLogo } from '#/common/hooks/useClientTheme';
import { color } from '@nuvolo/nuux-theme/utils';

export interface PoweredByProps {
  size?: 'small' | 'large';
}

const PoweredBy: React.FC<PoweredByProps> = ({ size = 'small' }) => {
  const isLarge = size === 'large';
  return (
    <NuvoBox alignItems="baseline">
      <NuvoText
        type={isLarge ? 'header4' : 'small'}
        inline
        case="sentence"
        color={color('custom', 'contrastText')}>
        Powered by&nbsp;
      </NuvoText>
      <NuvoloLogo style={{ height: isLarge ? '2em' : '1.75em', width: 'auto' }} />
    </NuvoBox>
  );
};

export default React.memo(PoweredBy);
